import apiClient from '../client'

const newSavedSearch = (customerId, savedSearchFilters) => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL, customerId)
  return client.post(`/home_buyer/saved_searches`, {
    saved_search: savedSearchFilters,
  })
}

const getSavedSearches = customerId => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL, customerId)
  return client.get(`/home_buyer/saved_searches`)
}

const removeSavedSearch = (customerId, locationId) => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL, customerId)
  return client.delete(`/home_buyer/saved_searches/${locationId}`)
}

export { newSavedSearch, removeSavedSearch, getSavedSearches }
